export default {
    webMobileLogin: "/gateway/huilian/customermanagercs/messageLogin", //账号密码登录
    getRegisterCode: "/gateway/manageBedrock/messagecs/messageCode", //获取验证码
    getPhotoValidCode: "/gateway/manageBedrock/messagecs/createImageCode", //获取图片验证码
};



// WEBPACK FOOTER //
// ./src/authCertificate/ACLogin/api.js